import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import DatatableDoctorInvoice from '../../pages/principal/invoice/doctor/DatatableDoctorInvoice'
import ShowDoctorInvoice from '../../pages/principal/invoice/doctor/ShowDoctorInvoice'
import DatatableClinicInvoice from '../../pages/principal/invoice/clinic/DatatableClinicInvoice'
import ShowClinicInvoice from '../../pages/principal/invoice/clinic/ShowClinicInvoice'

export enum PrincipalRoutesEnum {
    DatatableSendNotificationCenter = '/principal/central-de-notificacoes/enviar',
    DatatableSentNotificationCenter = '/principal/central-de-notificacoes/enviadas',
    DatatableClinicInvoice = '/principal/faturamento/estabelecimentos',
    ShowClinicInvoice = '/principal/faturamento/:id/estabelecimentos/:clinicId',
    DatatableDoctorInvoice = '/principal/faturamento/profissionais',
    ShowDoctorInvoice = '/principal/faturamento/:id/profissionais/:doctorId',
}

export function PrincipalRouter() {
    /*Rotas para Dashboard*/
    const DatatableSendNotificationCenter = lazy(
        () => import('../../pages/principal/notification-center/DatatableSendNotificationCenter')
    )
    const DatatableSentNotificationCenter = lazy(
        () => import('../../pages/principal/notification-center/DatatableSentNotificationCenter')
    )

    return (
        <Switch>
            {/*Rotas para Historico de Atividades*/}
            <Route
                path={PrincipalRoutesEnum.DatatableSendNotificationCenter}
                component={DatatableSendNotificationCenter}
            />
            <Route
                path={PrincipalRoutesEnum.DatatableSentNotificationCenter}
                component={DatatableSentNotificationCenter}
            />
            <Route path={PrincipalRoutesEnum.ShowClinicInvoice} component={ShowClinicInvoice} />
            <Route
                path={PrincipalRoutesEnum.DatatableClinicInvoice}
                component={DatatableClinicInvoice}
            />
            <Route path={PrincipalRoutesEnum.ShowDoctorInvoice} component={ShowDoctorInvoice} />
            <Route
                path={PrincipalRoutesEnum.DatatableDoctorInvoice}
                component={DatatableDoctorInvoice}
            />
        </Switch>
    )
}
